import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectIsAiEnabled } from '../selectors/chat';

// Used in useAiExperience. To remove this we need some new indication from userAction API
const AI_START_NODE_ID = '4e10b675-d3d4-44ae-ab7d-9d795b5a2ce0';
const AI_BOT_MESSAGE_NODE_ID = '7f92f12f-3bf6-4cc5-b912-885c48b331c4';
const AI_EDITOR_DISCLAIMER_NODE_ID = '71866c81-e3db-43bb-bb1a-3d007ff2d72e';
const AI_EDITOR_BUTTON_NODE_ID = '4f7749e7-923b-4f2b-81ec-73032f30648f';
const AI_PROHIBITED_TOPIC_NODE_ID = '60a12613-ed33-47cb-bd8c-3f0be68a547e';
const AI_CRITICAL_FLOW_CONFIRMATION_NODE_ID = 'f726fa4a-e9fc-4dcb-a16c-9539bce45702';
const AI_CRITICAL_FLOW_FOLLOW_UP_NODE_ID = '0c97c324-2e0a-4288-8af1-f35fb222c82c';

// AI nodes that can return BOT_MESSAGE
const AI_ALL_MESSAGE_NODE_IDS = [
  AI_START_NODE_ID,
  AI_BOT_MESSAGE_NODE_ID,
  AI_EDITOR_DISCLAIMER_NODE_ID,
  AI_EDITOR_BUTTON_NODE_ID,
  AI_PROHIBITED_TOPIC_NODE_ID,
  AI_CRITICAL_FLOW_CONFIRMATION_NODE_ID,
  AI_CRITICAL_FLOW_FOLLOW_UP_NODE_ID,
];
export const isAiMessageNodeId = (nodeId: string) => AI_ALL_MESSAGE_NODE_IDS.includes(nodeId);

/**
 * Identifies if the chat was started as AI Chatbot
 * This value can't change during conversation (don't be confused with AI Experience which can change during a conversation).
 */
export const useIsAiChatbot = () => {
  const isAiEnabled = useSelector(selectIsAiEnabled);
  return useMemo(() => isAiEnabled, [isAiEnabled]);
};
